import { useCallback, useEffect, useState } from 'react'
import { referralsService, type PortalReferral, type ReferralPublicStatus } from '@/services/referralsService'

export const PARCEIROS_LEADS_PAGE_SIZE = 20

export function useParceirosLeads(page: number) {
  const [rows, setRows] = useState<PortalReferral[]>([])
  const [total, setTotal] = useState(0)
  const [totalPages, setTotalPages] = useState(1)
  const [byStatus, setByStatus] = useState<Partial<Record<ReferralPublicStatus, number>>>({})
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const data = await referralsService.listMine(page, PARCEIROS_LEADS_PAGE_SIZE)
      setRows(data.data ?? [])
      setTotal(data.total ?? data.data?.length ?? 0)
      setTotalPages(Math.max(1, data.totalPages ?? 1))
      setByStatus(data.byStatus ?? {})
      setError('')
    } catch {
      setError('Não foi possível carregar suas indicações.')
    } finally {
      setLoading(false)
    }
  }, [page])

  useEffect(() => {
    void load()
  }, [load])

  return {
    rows,
    total,
    totalPages,
    byStatus,
    error,
    loading,
    reload: load,
    pageSize: PARCEIROS_LEADS_PAGE_SIZE,
  }
}
